import { enumObject, EnumValue } from '@/utils';

const ANNOUNCEMENT_STATUS_VALUES = ['Draft', 'Published'] as const;

export type AnnouncementStatus = EnumValue<typeof ANNOUNCEMENT_STATUS_VALUES>;

// eslint-disable-next-line
export const AnnouncementStatus = enumObject(
  'AnnouncementStatus',
  ANNOUNCEMENT_STATUS_VALUES,
);

export type AddAnnouncementDto = {
  title: string;
  body: string;
  startDate: any;
  endDate: any;
  attachmentIds?: string[] | null;
};

export interface AnnouncementDto {
  id: string;
  number: string;
  title: string;
  body: string;
  period: {
    start: string;
    end: string | null;
  };
  createdAt: string;
  updatedAt: string;
  status: AnnouncementStatus;
}

export interface AnnouncementLookupDto {
  id: string;
  number: string;
  title: string;
  period: {
    start: string;
    end: string | null;
  };
  updatedAt: string;
  status: AnnouncementStatus;
}

export interface UpdateAnnouncementDto extends AddAnnouncementDto {
  id: string;
}
